// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point, Rectangle } from '@shared/commons/Geometry';
import { DataCacheToolRayType, DataCacheToolType } from '@shared/commons/cache/DataCacheToolEnums';
import { ToolView } from './ToolView';
import { SelectionState } from './Selection';
export class ElliotWaveToolView extends ToolView {
    constructor(tool, fromRepopulate) {
        super(tool);
        this.InitPointLabels(tool);
        if (!fromRepopulate) {
            this.SelectTool();
        }
    }
    Draw(gr, ww, param) {
        param.isNeedConnectFirstAndLastPoints = false; // first comment in #115784
        this.DrawElliot(gr, ww, false);
        super.Draw(gr, ww, param);
    }
    DrawElliot(gr, ww, highlight) {
        if (this.isDisposed || gr == null || ww == null || this.dataCacheTool == null) {
            return;
        }
        const cacheTool = this.dataCacheTool;
        // const pen = highlight ? cacheTool.PenHighlight : cacheTool.Pen;
        // const clientRect = ww.ClientRectangle;
        const screenPoints = this.screenPoints;
        const pointsCount = 
        /* this.CurrentMovement.CreationState ? dataCacheTool.PointsInitialized : */ cacheTool.PointLevel();
        if (pointsCount < 2) {
            return;
        }
        // Draw Lines
        for (let i = 0; i < pointsCount - 1; i++) {
            const start = new Point(screenPoints[i][0], screenPoints[i][1]);
            const end = new Point(screenPoints[i + 1][0], screenPoints[i + 1][1]);
            ToolView.DrawLineWithRay(gr, ww, start.X, start.Y, end.X, end.Y, DataCacheToolRayType.NoRay, cacheTool.Pen);
        }
        // Draw labels
        const labelsDrawNumber = cacheTool.InitedPointsNumber;
        for (let i = 0; i < pointsCount - 1; i++) {
            const start = new Point(screenPoints[i][0], screenPoints[i][1]);
            const end = new Point(screenPoints[i + 1][0], screenPoints[i + 1][1]);
            if (i < labelsDrawNumber) {
                if (i === 0) // Draw first label
                 {
                    const drawFirstLabel = this.CurrentSelection.CurrentState === SelectionState.Selected || !cacheTool.completed;
                    if (drawFirstLabel) {
                        this.DrawLabel(gr, i, start, start.Y > end.Y);
                    }
                }
                this.DrawLabel(gr, i + 1, end, end.Y > start.Y);
            }
        }
    }
    DrawLabel(gr, index, point, isTop) {
        const tool = this.dataCacheTool;
        const label = this.GetPointLabel(index);
        if (!tool || !label) {
            return;
        }
        const labelTextWidth = gr.GetTextWidth(label, tool.font);
        const labelSize = labelTextWidth + ElliotWaveToolView.LABEL_PADDING_LEFT + ElliotWaveToolView.LABEL_PADDING_RIGHT;
        const x = point.X - labelSize / 2;
        const y = isTop
            ? point.Y + ElliotWaveToolView.UPPER_LABEL_Y_OFFSET
            : point.Y - ElliotWaveToolView.LOWER_LABEL_Y_OFFSET;
        const labelRect = new Rectangle(x, y - labelSize, labelSize, ElliotWaveToolView.LABEL_HEIGHT);
        const isMovementLabel = this.CurrentMovement.MovingPointNo === index;
        const backBrush = isMovementLabel ? tool.labelBackgroundSelectedBrush : tool.labelBackgroundBrush;
        const foreBrush = isMovementLabel ? tool.foregroundSelectedBrush : tool.FontBrush;
        gr.RoundRectangle(labelRect, ElliotWaveToolView.LABEL_BORDER_RADIUS, backBrush);
        gr.DrawStringInRect(label, tool.font, foreBrush, labelRect, false, 'center', 'middle');
    }
    InitPointLabels(tool) {
        if (!tool) {
            return;
        }
        this.AddPointLabel(0, '0');
        switch (tool.ToolType) {
            case DataCacheToolType.ElliottImpulse:
                this.AddPointLabel(1, '1');
                this.AddPointLabel(2, '2');
                this.AddPointLabel(3, '3');
                this.AddPointLabel(4, '4');
                this.AddPointLabel(5, '5');
                break;
            case DataCacheToolType.ElliottCorrection:
                this.AddPointLabel(1, 'A');
                this.AddPointLabel(2, 'B');
                this.AddPointLabel(3, 'C');
                break;
            case DataCacheToolType.ElliottTriangle:
                this.AddPointLabel(1, 'A');
                this.AddPointLabel(2, 'B');
                this.AddPointLabel(3, 'C');
                this.AddPointLabel(4, 'D');
                this.AddPointLabel(5, 'E');
                break;
            case DataCacheToolType.ElliottTripleCombo:
                this.AddPointLabel(1, 'W');
                this.AddPointLabel(2, 'X');
                this.AddPointLabel(3, 'Y');
                this.AddPointLabel(4, 'X');
                this.AddPointLabel(5, 'Z');
                break;
            case DataCacheToolType.ElliottDoubleCombo:
                this.AddPointLabel(1, 'W');
                this.AddPointLabel(2, 'X');
                this.AddPointLabel(3, 'Y');
                break;
        }
        // const cacheTool = this.dataCacheTool;
        // if (cacheTool)
        //     cacheTool.InitPointLabels()
    }
}
ElliotWaveToolView.LABEL_BORDER_RADIUS = 4; // all corners with 4px border-radius
ElliotWaveToolView.LABEL_PADDING_LEFT = 3;
ElliotWaveToolView.LABEL_PADDING_RIGHT = 2;
ElliotWaveToolView.LABEL_HEIGHT = 18;
ElliotWaveToolView.LABEL_SIZE = 14;
ElliotWaveToolView.LABEL_OFFSET = 10;
ElliotWaveToolView.UPPER_LABEL_Y_OFFSET = (() => {
    return ElliotWaveToolView.LABEL_OFFSET + ElliotWaveToolView.LABEL_SIZE;
})();
ElliotWaveToolView.LOWER_LABEL_Y_OFFSET = (() => {
    return ElliotWaveToolView.LABEL_OFFSET + 0.5 * ElliotWaveToolView.LABEL_SIZE;
})();
